import type { JSX, PropsWithChildren } from 'react'

import { Flex } from '@buffer-mono/popcorn'

function InsightsToolbarRoot({ children }: PropsWithChildren): JSX.Element {
  return (
    <Flex direction="row" align="center" gap="md" justify="between" fullWidth>
      {children}
    </Flex>
  )
}

function InsightsToolbarFilters({ children }: PropsWithChildren): JSX.Element {
  return (
    <Flex align="center" gap="sm">
      {children}
    </Flex>
  )
}

export const InsightsToolbar = Object.assign(InsightsToolbarRoot, {
  Filters: InsightsToolbarFilters,
})
